import {createSlice} from "@reduxjs/toolkit";

const initialState = {
    drivers: []
}

const driverSlice = createSlice({
    name: 'driver',
    initialState,
    reducers: {
        setDrivers: (state, action) => {
            state.drivers = action.payload
        },
        addDriver: (state, action) => {
            state.drivers.push(action.payload);
        }
    }
});


export const {setDrivers, addDriver} = driverSlice.actions;
export default driverSlice.reducer;
